import { useCollapse } from 'react-collapsed';
import { EXPANDING_ANIMATION, EXPANDING_DURATION_MS } from '../constants';
export const useExpandCollapse = (expanded) => {
    return useCollapse({
        isExpanded: expanded ?? true,
        duration: EXPANDING_DURATION_MS,
        easing: EXPANDING_ANIMATION,
    });
};
